const MESSAGEMEDIA = "mm";
const MULTITXT = "vodanz";
const DIRECTSMS = "directSMS";
const STREETDATA = "streetdata";
const WHOLESALESMS = "wholesale";
const TWO_DEGREES = "2degrees";
const SMSB = "smsb";
const MESSAGENET = "messagenet";
const MOBIPOST = "mobipost";
const SMSCENTRAL = "smscentral";
const BULLETIN = "bulletin";
const ETXT = "etxt";
const TPGTELECOM = "tpgtelecom";
const SIMPLE_TEXTING = "simpletexting";
const MESSAGE_STUDIO = "messagestudio";
const SINCH_EU = "sincheu";
const APP_SINCH = "app-sinch";
const NOTIFY_NOW = "notify-now";

export const BRANDS = [
  MESSAGEMEDIA,
  MULTITXT,
  DIRECTSMS,
  STREETDATA,
  WHOLESALESMS,
  TWO_DEGREES,
  SMSB,
  MESSAGENET,
  MOBIPOST,
  SMSCENTRAL,
  BULLETIN,
  ETXT,
  TPGTELECOM,
  SIMPLE_TEXTING,
  MESSAGE_STUDIO,
  SINCH_EU,
  APP_SINCH,
  NOTIFY_NOW,
];
